import React from 'react';
import Modal from 'react-modal';

import SendTestForm from './SendTestForm';

class SendTestModal extends React.Component {
  state = {
    submitted: false,
    error: null
  }

  componentWillMount() {
    Modal.setAppElement('body');
  }

  handleSuccess = () => {
    this.setState({ submitted: true, error: null });
  }

  handleError = (message) => {
    console.log(message);
    this.setState({ submitted: true, error: message });
  }

  renderErrorMessage = () => {
    return (
      <div>{ i18n.t('send_test.error') }: {this.state.error}</div>
    );
  }

  renderSuccessMessage = () => {
    return (
      <div>
        <div className="success-icon">
          <span className="success-icon_line success-icon_tip"></span>
          <span className="success-icon_line success-icon_long"></span>
          <div className="success-icon_placeholder"></div>
          <div className="success-icon_fix"></div>
        </div>
        <div className="success-message">{ i18n.t('send_test.success') }</div>
      </div>
    );
  }

  render() {
    return (
      <Modal isOpen shouldCloseOnOverlayClick={false} contentLabel={ i18n.t('send_test.select') } className="modal fade in send-test">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <button className="close" onClick={this.props.closeModal}>
                <span>×</span>
              </button>
              <h2>{ i18n.t('send_test.head') }</h2>
            </div>
            <div className="modal-body">
              { this.state.submitted && !this.state.error && this.renderSuccessMessage() }
              { this.state.submitted && this.state.error && this.renderErrorMessage() }
              { !this.state.submitted &&
                  <SendTestForm handleSuccess={this.handleSuccess} handleError={this.handleError}/>
              }
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default SendTestModal;
